/* eslint-disable */

/** unique or primary key constraints on table "argo.work_order_restriction" */
export enum ArgoWorkOrderRestrictionConstraint {
  /** unique or primary key constraint on columns "restriction" */
  WorkOrderRestrictionPkey = 'work_order_restriction_pkey'
}

export enum ArgoWorkOrderRestrictionEnum {
  /** Can be completed at anytime */
  None = 'none',
  /** Only after the target quantity of associated material has been reached and completed, can the work order be completed */
  TargetQuantityCompleted = 'target_quantity_completed',
  /** Only after the target quantity of associated material has been reached, can the work order be completed */
  TargetQuantityCreated = 'target_quantity_created'
}

/** select columns of table "argo.work_order_restriction" */
export enum ArgoWorkOrderRestrictionSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Restriction = 'restriction'
}

/** update columns of table "argo.work_order_restriction" */
export enum ArgoWorkOrderRestrictionUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Restriction = 'restriction'
}

